import styles from "./PlacementsPage.module.css";
import PlacementList from "components/PlacementList";
import { StaticRoutes } from "../routes";
import { PageNav, PageHeader, HeaderSection } from "@cpnw/ui";

export function PlacementsPage() {
  const southRegionList = PlacementList({
    items: [
      {
        label: "American Lake VA",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/South/amLakeVA.pdf?638514477635375008",
      },
      {
        label: "VMFH Franciscan Hospice",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/South/franciscanhospice.pdf",
      },
      {
        label: "VMFH St. Anthony Hospital",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/South/stAnthony.pdf?638514477635375008",
      },
      {
        label: "VMFH St. Clare Hospital",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/South/stClare.pdf?638514477635375008",
      },
      {
        label: "VMFH St. Elizabeth Hospital",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/South/stElizabeth.pdf?638514477635375008",
      },
      {
        label: "VMFH St. Francis Hospital",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/South/stFrancis.pdf?638514477635375008",
      },
      {
        label: "VMFH St. Joseph Hospital",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/South/stJoseph.pdf?638514477635375008",
      },
      {
        label: "VMFH St. Michael Medical Center",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/South/stMichael.pdf?638514477635375008",
      },
      {
        label: "Mason General",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/South/masonGen.pdf?638514477635375008",
      },
      {
        label: "MultiCare Mary Bridge Children's Hospital",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/South/maryBridge.pdf?638514477635375008",
      },
      {
        label: "MultiCare Adult Day Health",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/South/mcAdultHealth.pdf?638514477635375008",
      },
      {
        label: "MultiCare Allenmore",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/South/allenmore.pdf?638514477635375008",
      },
      {
        label: "MultiCare Auburn Medical Center",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/South/mcAuburn.pdf?638514477635375008",
      },
      {
        label: "MultiCare Capital Medical Center",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/South/mcCapital.pdf?638514477635375008",
      },
      {
        label: "MultiCare Covington",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/South/mcCovington.pdf?638514477635375008",
      },
      {
        label: "MultiCare Good Samaritan",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/South/goodSam.pdf?638514477635375008",
      },
      {
        label: "MultiCare Tacoma General",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/South/tacomaGeneral.pdf?638514477635375008",
      },
      {
        label: "Providence Centralia",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/South/provCentralia.pdf?638514477635375008",
      },
      {
        label: "Providence St. Peter Hospital",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/South/provStPete.pdf?638514477635375008",
      },
      {
        label: "Western State Hospital",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/South/westernState.pdf?638514477635375008",
      },
    ],
    header: "South Region",
  });

  const northRegionList = PlacementList({
    items: [
      {
        label: "EvergreenHealth",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/North/evergreenHealth.pdf?638514546429008243",
      },
      {
        label: "Harborview Medical Center",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/North/harborview.pdf?638514546429008243",
      },
      {
        label: "Harborview Medical Center - AACS",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/North/harborviewAACS.pdf?638514546429008243",
      },
      {
        label: "MultiCare Navos Hospital",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/North/mcNavos.pdf?638514546429008243",
      },
      {
        label: "VMFH St. Anne Hospital",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/North/stAnne.pdf?638514546429008243",
      },
      {
        label: "Overlake Medical Center",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/North/overlake.pdf?638514546429008243",
      },
      {
        label: "Providence Regional Medical Center Everett",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/North/provEverett.pdf?638514546429008243",
      },
      {
        label: "Providence Regional Medical Center Pacific",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/North/provEverettPacific.pdf?638514546429008243",
      },
      {
        label: "Seattle Children's Hospital",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/North/seattleChildrens.pdf?638514546429008243",
      },
      {
        label: "Seattle VA Medical Center",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/North/seattleVA.pdf?638514546429008243",
      },
      {
        label: "Swedish Medical Center: Ballard",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/North/swBallard.pdf?638514546429008243",
      },
      {
        label: "Swedish Medical Center: Cherry Hill",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/North/swCherryHill.pdf?638514546429008243",
      },
      {
        label: "Swedish Medical Center: Edmonds",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/North/swEdmonds.pdf?638514546429008243",
      },
      {
        label: "Swedish Medical Center: First Hill",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/North/swFirstHill.pdf?638514546429008243",
      },
      {
        label: "Swedish Medical Center: Issaquah",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/North/swIssaquah.pdf?638514546429008243",
      },
      {
        label: "Swedish Medical Center: Mill Creek",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/North/swMillCreek.pdf?638514546429008243",
      },
      {
        label: "Swedish Medical Center:OR",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/North/swOR.pdf?638514546429008243",
      },
      {
        label: "Valley Medical Center",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/North/vMedicalCenter.pdf?638514546429008243",
      },
      {
        label: "Virginia Mason Franciscan Health",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/North/virginiaMason.pdf?638514546429008243",
      },
    ],
    header: "North Region",
  });

  const eastRegionList = PlacementList({
    items: [
      {
        label: "Eastern State Hospital",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/East/easternState.pdf?638514546429008243",
      },
      {
        label: "MultiCare Deaconess Hospital",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/East/deaconess.pdf?638514546429008243",
      },
      {
        label: "MultiCare Valley Hospital",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/East/valleyHospital.pdf?638514546429008243",
      },
      {
        label: "Odessa Memorial Healthcare Center",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/East/odessa.pdf?638514546429008243",
      },
      {
        label: "Providence Holy Family Hospital",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/East/provHolyFamily.pdf?638514546429008243",
      },
      {
        label: "Providence Sacred Heart Medical Center",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/East/provSacredHeart.pdf?638514546429008243",
      },
      {
        label: "Providence St. Luke's Rehabilitation Medical Center",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/East/stLukes.pdf?638514546429008243",
      },
      {
        label: "VA Spokane",
        src: "https://cpnw.blob.core.windows.net/documents/Grids/East/vaSpokane.pdf?638514546429008243",
      },
    ],
    header: "East Region",
  });
  
  return (
    <div className={styles.placementsPage}>
      <PageHeader name="Placements" />
      <div className={styles.contentContainer}>
        <div className={styles.nav}>
          <a className={styles.a} href={StaticRoutes.AboutUs}>
            About Us
          </a>
          <PageNav
            links={[
              {
                name: "Healthcare Partners",
                src: StaticRoutes.AboutUsHealthcarePartners,
              },
              {
                name: "Participating Programs",
                src: StaticRoutes.AboutUsParticipatingPrograms,
              },
              {
                name: "Nursing Placement",
                src: StaticRoutes.AboutUsNursingPlacement,
              },
            ]}
          />
        </div>
        <div className={styles.mainContent}>
          <HeaderSection header="Clinical Placements" />
          <h3>Nursing placement grids are posted yearly on July 1 to reflect the new academic year.</h3>
          <div className={styles.row}>
            <div>{southRegionList}</div>
            <div>{northRegionList}</div>
          </div>
          <div className={styles.row}>
            <div>{eastRegionList}</div>
            <div className={styles.gridTut}>
              <h2>The Placement Grid</h2>
              <p>
                <a href="https://view.officeapps.live.com/op/view.aspx?src=https%3A%2F%2Fcpnw.blob.core.windows.net%2Fdocuments%2FdocDownloads%2FStatewide%2FClinicalPlacementGrid.pptx&wdOrigin=BROWSELINK">
                  Click here{" "}
                </a>
                for a tutorial on reading the Placement Grid.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlacementsPage;
